import { AdvancedSearchJobsGetters } from './partials/search-jobs'

export const AdvancedSearchGetters = {
  embeddedSearchQuery: state => state.embeddedSearchQuery,
  entities: state => state.entities,
  entityParamsInGroup: (state, getters) => id => getters.groupById(id)?.entity_params || {},
  fields: state => state.exportable_fields,
  fieldsByGroupId: (state, getters) => id => getters.propertiesByGroupId(id)?.fields?.searchable_fields || [],
  getIndistinctResults: state => state.indistinctResults,
  groupById: state => id => state.query_groups.find(g => g.sequence === id),
  interGroupOperator: state => state.interGroupOperator,
  loadingAdvancedSearch: state => state.loadingAdvancedSearch,
  nestedParamsInGroup: (state, getters) => id => getters.groupById(id)?.nested_params || [],
  operatorsByGroupId: (state, getters) => id => getters.propertiesByGroupId(id)?.operators || {},
  paramsInGroupBySequence: (state, getters) => (id, sequence) => sequence ? getters.nestedParamsInGroup(id).find(n => n.sequence === sequence) : getters.entityParamsInGroup(id),
  propertiesByGroupId: (state, getters) => id => getters.groupById(id)?.properties || {},
  queryFields: state => state.exportable_fields_query,
  queryGroups: state => state.query_groups,
  resultantEntity: state => state.entity,
  resultEntity: state => state.entities.find(e => e.value === state.entity),
  resultHeaders: state => (state.search_results.columns || []).map(r => ({ text: r.header, value: r.prop_path })),
  resultRows: state => (state.search_results.rows || []).map(r => ({ ...r.value, link_to: r.link_to })),
  searchableEntities: state => state.entities || [],
  searchedQuery: state => {
    return {
      entity: state.entity,
      query_groups: state.query_groups,
      interGroupOperator: state.interGroupOperator,
    }
  },
  searchResults: state => state.search_results,
  selectedEntityInGroup: (state, getters) => id => getters.entityParamsInGroup(id)?.entity,
  selectedFieldInParams: (state, getters) => (id, sequence) => getters.paramsInGroupBySequence(id, sequence)?.field,
  selectedOperatorInParams: (state, getters) => (id, sequence) => getters.paramsInGroupBySequence(id, sequence)?.operator,
  selectedResults: state => state.selected_results,
  selectedTermInParams: (state, getters) => (id, sequence) => getters.paramsInGroupBySequence(id, sequence)?.term,
  showDialog: state => state.show_export_dialog,
  showSavedQueriesDialog: state => state.savedQueriesDialog,
  ...AdvancedSearchJobsGetters,
}
